export default "__VITE_ASSET__C$aLEw$f__"